import { render, staticRenderFns } from "./BasicSubMenu.vue?vue&type=template&id=51b13a61&scoped=true&"
import script from "./BasicSubMenu.vue?vue&type=script&lang=js&"
export * from "./BasicSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./BasicSubMenu.vue?vue&type=style&index=0&id=51b13a61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b13a61",
  null
  
)

export default component.exports